import { UpdateCurrentUserGenderScreenProps } from "./types"
import React from "react"
import { observer } from "mobx-react-lite"
import { alertSuccess } from "~utils/alert"
import useNavigation from "~hooks/useNavigation"
import { UpdateForm } from "~components/update-form"
import { useStores } from "~models"
import { Event, EventNames, UserUpdateData, FLAG_ACK, UserGender } from "~proto"

const UpdateCurrentUserGender: React.FC<UpdateCurrentUserGenderScreenProps> = () => {
  const navigation = useNavigation()
  const { eventStore, userStore } = useStores()

  const inputs = [
    {
      inputType: "radio-group",
      key: "gender",
      label: "性别",
      defaultValue: userStore.currentUser.gender,
      options: [
        {
          label: "男",
          value: UserGender.MALE,
        },
        {
          label: "女",
          value: UserGender.FEMALE,
        },
      ],
    },
  ]

  const modalPageTitle = "修改性别"

  const modalPageSubTitle = ""

  const onLeftPress = () => navigation.goBack()

  const handleSubmit = (values) => {
    const evt = new Event<Partial<UserUpdateData>>(EventNames.USER_UPDATE, {
      ...values,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
    alertSuccess({ message: "修改成功" })
    navigation.goBack()
  }

  const handleCancel = () => navigation.goBack()

  const disabledFunc = ({ gender }) => {
    return gender === userStore.currentUser.gender
  }

  return (
    <UpdateForm
      modalPageTitle={modalPageTitle}
      modalPageSubTitle={modalPageSubTitle}
      onLeftPress={onLeftPress}
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      disabledFunc={disabledFunc}
      inputs={inputs}
    />
  )
}

export default observer(UpdateCurrentUserGender)
